import { Modal, Table, Button } from 'antd'
import { useMount, useSetState } from 'ahooks'
import { useEffect, useRef, useState } from 'react'
import { useTableData } from '@/hooks/useTableData'
import { getMemberInfoList } from '@/pages/documentCompile/api/memberInfo'
import { formatDate } from '@/utils/date'
import Search from '../search'
import type { MemberInfo } from '@/pages/documentCompile/baseInfo/type'
import { getDictTableData } from '@/pages/documentCompile/dict/utils'
import { DictData } from '@/pages/documentCompile/dict/type'
import { TemplateCode } from '../../constant'
import { transformBaseInfoTableData } from '../../../util'
import styles from './index.module.less'

interface PersonTableModalProps {
    open: boolean
    onOk: (record: MemberInfo) => void
    onCancel: () => void
}

interface TableStateType {
    tableData?: MemberInfo[]
    dictData?: DictData[]
    flattenedTableData?: any[]
    selectedRowKey?: string | null
}

const PersonTableModal: React.FC<PersonTableModalProps> = ({ open, onOk, onCancel }) => {
    const searchParams = useRef<any>({})
    const refDictMap = useRef<any>({})

    const getList = async params => {
        // 设置较大的pageSize，不分页
        const data = await getMemberInfoList({ ...params, pageSize: 2000, pageIndex: 1 }) as any
        return {
            total: data.totalCount,
            list: data.result,
        }
    }

    const { data, loading, search } = useTableData({
        initialParams: {
            pageSize: 2000,
            pageIndex: 1,
        },
        service: getList,
    })

    const [state, setState] = useSetState<TableStateType>({
        tableData: [],
        dictData: [],
        flattenedTableData: [],
        selectedRowKey: null,
    })

    // 生成动态列
    const generateDynamicColumns = (dictData: DictData[]) => {
        const baseColumns = [
            {
                title: '序号',
                width: 60,
                dataIndex: 'number',
                className: 'text-center',
                render: (_text, _record, index) => {
                    return <span>{index + 1}</span>
                },
            },
            // {
            //     title: '人员名称',
            //     width: 120,
            //     dataIndex: 'name',
            //     render: (v) => v || '-'
            // },
        ]

        // 根据字典数据生成动态列
        dictData.sort((a, b) => a.sort - b.sort)
        const dictDataTemp = dictData.filter((dItem => dItem.enable))
        const dynamicColumns = dictDataTemp.map(dictItem => ({
            title: dictItem.dictName,
            width: 150,
            dataIndex: `attr_${dictItem.dictCode}`,
            render: (value) => {
                if (!value) return '-'

                if (dictItem.attr_nr && Array.isArray(dictItem.attr_nr)) {
                    const option = dictItem.attr_nr.find(item => item.value === value)
                    return option ? option.label : value
                }

                return value
            }
        }))

        const endColumns = [
            {
                title: '创建人',
                width: 100,
                dataIndex: 'createBy',
            },
            {
                title: '修改日期',
                width: 160,
                dataIndex: 'updateTime',
                render: text => formatDate(text, 'YYYY-MM-DD HH:mm:ss')
            },
        ]

        return [...baseColumns, ...dynamicColumns, ...endColumns]
    }

    const columns = generateDynamicColumns(state.dictData || [])

    const handleSearch = params => {
        searchParams.current = params
        search(params)
    }

    const handleOk = () => {
        if (!state.selectedRowKey) {
            return
        }
        const selectedRecord = state.flattenedTableData.find(item => item.id === state.selectedRowKey)
        onOk(selectedRecord)
    }

    // 获取字典数据
    useMount(() => {
        getDictTableData(TemplateCode).then(res => {
            res.forEach(item => {
                refDictMap.current[item.dictCode] = item
            })
            setState({
                dictData: res,
            })
        })
    })

    useEffect(() => {
        if (data && state.dictData) {
            const flattenedData = transformBaseInfoTableData(data)
            setState({
                tableData: data,
                flattenedTableData: flattenedData,
            })
        }
    }, [data, state.dictData])

    return (
        <Modal
            title="人员选择"
            open={open}
            width={1200}
            onOk={handleOk}
            onCancel={onCancel}
            destroyOnClose
        >
            <div className={styles.container}>
                {/* <Search onSearch={handleSearch} loading={loading} onCreate={() => {}} /> */}
                <div className={styles.tableWrap}>
                    <Table
                        rowKey='id'
                        bordered
                        columns={columns}
                        dataSource={state.flattenedTableData}
                        pagination={false}
                        scroll={{ y: '50vh', x: 'max-content' }}
                        loading={loading}
                        size='small'
                        rowSelection={{
                            type: 'radio',
                            selectedRowKeys: state.selectedRowKey ? [state.selectedRowKey] : [],
                            onChange: (selectedRowKeys) => {
                                setState({ selectedRowKey: selectedRowKeys[0] as string })
                            }
                        }}
                    />
                </div>
            </div>
        </Modal>
    )
}

export default PersonTableModal 
